import React, { Suspense } from 'react'
import { useTranslation } from 'react-i18next'
import { ErrorBoundary } from 'react-error-boundary'

import { Layout } from '../Layout/Layout'
import { getLatestMessage, isNewMessage } from '../../../utils/newMessage'

import { useAPIGetResidentMessageTimeline } from 'api/apiHooks/useAPIGetResidentMessageTimeline'

const MessagesLinkLabelWithCount: React.FC<{ label: string }> = ({ label }) => {
  const { t } = useTranslation(['common'])
  const { data } = useAPIGetResidentMessageTimeline()
  const newMessageThreadsCount = data.messages.filter((thread) => {
    const latestMessage = getLatestMessage(thread.entries)
    return latestMessage !== undefined && isNewMessage(latestMessage)
  }).length

  return (
    <Layout.LinkLabel
      label={label}
      icon="email"
      count={newMessageThreadsCount}
      countLabel={t('common:taskLinks.newMessagesCount', {
        count: newMessageThreadsCount,
      })}
    />
  )
}

export const MessagesLinkLabel: React.FC = () => {
  const { t } = useTranslation(['common'])
  const label = t('common:taskLinks.messages')
  const labelWithoutCount = <Layout.LinkLabel label={label} icon="email" />

  return (
    <ErrorBoundary fallback={labelWithoutCount}>
      <Suspense fallback={labelWithoutCount}>
        <MessagesLinkLabelWithCount label={label} />
      </Suspense>
    </ErrorBoundary>
  )
}
